import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

const WiFiFrequencySelect = (props) => {

  const [wifiFrequency, setWifiFrequency] = useState(props.wifiFrequency);

  const handleWifiFrequencyChanged = (event) => {
    setWifiFrequency(event.target.value);
    if (props.onChange) {
      props.onChange({"wifiFrequency": event.target.value});
    } else {
      console.error("WifiFrequency changed handler not defined");
    }
  };

  useEffect(() => {
    setWifiFrequency(props.wifiFrequency);
  }, [props.wifiFrequency]);

  return (
    <TextField 
      select
      onChange={handleWifiFrequencyChanged}
      disabled={props.disabled}
      value={wifiFrequency ?? "2.4"}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      <MenuItem key={'2.4'} value={'2.4'}>2.4 Ghz</MenuItem>
      <MenuItem key={'5'} value={'5'}>5 Ghz</MenuItem>
    </TextField>
  );
};

export default WiFiFrequencySelect;